import { parsePhoneNumber } from "libphonenumber-js";
import queryString from "query-string";

import { head } from "@utils/array";
import { attemptMethod } from "@utils/general";

import { CustomerModel } from "@redux/modules/api/data/customer/@types/customer.model";
import { PhonenumberPrefix } from "@redux/modules/api/data/phonenumberPrefixes/phonenumberPrefixes.types";

import {
    Category,
    ContactCustomerServiceForm,
} from "@components/ContactCustomerservice/contactCustomerservice.types";

const getStoreId = (customer?: CustomerModel | null) =>
    customer?.favouriteStoreId ??
    attemptMethod<string | undefined>(
        () => queryString.parse(location.search)["storeId"]?.toString(),
        undefined,
    ) ??
    "";

export const getInitialFormValues = (
    customer?: CustomerModel | null,
    categories?: Array<Category>,
): ContactCustomerServiceForm => ({
    category: head(categories ?? [])?.code,
    firstName: customer?.firstName ?? undefined,
    lastName: customer?.lastName ?? undefined,
    email: customer?.email ?? undefined,
    storeId: getStoreId(customer),
    phonePrefix: customer?.phonePrefix ?? undefined,
    phone: customer?.phone ?? undefined,
    bonusCardNumber: customer?.bonusCardNumber ?? undefined,
});

export const getPhone = (
    phonenumberPrefixes: PhonenumberPrefix[],
    prefix?: string,
    phone?: string,
) => {
    let newPhone = undefined;
    if (prefix && phone) {
        const phonePrefix = phonenumberPrefixes.find(p => p.prefix === prefix);
        if (phonePrefix) {
            try {
                newPhone = parsePhoneNumber(
                    `${prefix}${phone}`,
                    phonePrefix.country.isoCode,
                );
            } catch (_) {
                newPhone = undefined;
            }
        }
    }
    return newPhone?.isValid() ? newPhone.number : undefined;
};

export const getCategoryByCode =
    (categories: Array<Category>) => (code?: string) =>
        categories.find(c => c.code === code)?.name;

export const categoriesToFormOptions = (categories: Array<Category>) =>
    categories.map(({ name, code }) => ({
        label: name,
        value: code,
    }));

export const emptyFormValues: ContactCustomerServiceForm = {
    firstName: "",
    lastName: "",
    phonePrefix: "+32",
    phone: "",
    orderId: "",
    bonusCardNumber: "",
    category: "",
    email: "",
    message: "",
    storeId: "",
};
